<template>
    <div>
        <div :key="formField.id" v-for="formField in formFields">
            <div class="form-group">
                <label for="" class="control-label">{{ formField.question }}</label>
                <text-input
                    :id="`form-renderer-form-field-${formField.question}-${formField.id}`"
                    @input="e => $emit('input', {...value, [formField.id]: e})"
                    :name="`form-renderer-form-field-${formField.question}-${formField.id}`"
                    :value="Object.hasOwnProperty.call(value, formField.id) ? value[formField.id] : ''"
                    v-if="formField.input_type === 'text'"
                ></text-input>
                <select
                    @change="e => $emit('input', {...value, [formField.id]: e.target.value})"
                    class="form-control"
                    :id="`form-renderer-form-field-${formField.question}-${formField.id}`"
                    :name="`form-renderer-form-field-${formField.question}-${formField.id}`"
                    :value="Object.hasOwnProperty.call(value, formField.id) ? value[formField.id] : ''"
                    v-else-if="formField.input_type === 'multiple_choice'"
                >
                    <option
                        disabled
                        selected
                        value=""
                        v-if="!value.length"
                    >
                        -- Select --
                    </option>
                    <option
                        :key="option.id"
                        :value="option.id"
                        v-for="option in formField.choices"
                    >
                        {{ option.name }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import TextInput from "../../InputFields/TextInput.vue";

export default {
    name: 'FormRenderer',

    components: {
        TextInput,
    },

    props: {
        formFields: {
            required: true,
            type: Array,
        },
        value: {
            required: true,
            validator: value => typeof value === 'object' || value === null,
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Forms/FormRenderer/FirstIteration/FormRenderer.vue